module.exports = __webpack_public_path__ + "static/media/icon-close-search.897185f5.png";